/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @fileoverview Contains token used when registering as a downgraded service in AJS
 *
 * @author vgohil
 */

/**
 * Ajs dependency token for HSMGroup Download Certificate service.
 */
export const HSM_GROUP_DOWNLOAD_CERTIFICATE_MODAL_SERVICE_TOKEN =
    'hsmGroupDownloadCertificateModalService';

/**
 * Ajs dependency token for App Level Alerts service.
 */
export const APP_LEVEL_ALERTS_SERVICE_TOKEN = 'appLevelAlertsService';

/**
 * Ajs dependency token for Central License Alerts service.
 */
export const CENTRAL_LICENSE_ALERT_SERVICE_TOKEN = 'centralLicenseAlertsService';

/**
 * Ajs dependency token for Verify Cloud Connector User Host Modal service.
 */
export const VERIFY_CLOUD_CONNECTOR_USER_HOST_MODAL_SERVICE_TOKEN =
    'VerifyCloudConnectorUserHostModalService';

/*
 * Ajs dependency token for Recommendation Dialog service.
 */
export const RECOMMENDATION_DIALOG_SERVICE_TOKEN = 'recommendationDialogService';

/**
 * Ajs dependency token for the Virtual Service State service.
 */
export const VIRTUAL_SERVICE_STATE_SERVICE_TOKEN = 'virtualServiceStateService';

/**
 * Ajs dependency token for the Pool State service.
 */
export const POOL_STATE_SERVICE_TOKEN = 'poolStateService';

export const CONTROLLER_FAULTS_SERVICE_TOKEN = 'controllerFaultsService';

export const CSRF_POLICY_COLLECTION_TOKEN = 'CSRFPolicyCollection';

/**
 * Ajs dependency token for Update Helper service.
 */
export const UPDATE_HELPER_SERVICE_TOKEN = 'updateHelperService';

/**
 * Ajs dependency token for Update service.
 */
export const UPDATE_SERVICE_TOKEN = 'updateService';

export const ALERT_SYSLOG_CONFIG_COLLECTION_TOKEN = 'AlertSyslogConfigCollection';

/**
 * Ajs dependency token for Vs Logs Data Transformer Service.
 */
export const VS_LOG_DATA_TRANSFORMER_SERVICE_TOKEN = 'logDataTransform';

